var _path, _g, _g2, _path2, _g3, _g4, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoViralWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 280,
    viewBox: "0 0 660 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.704 100.776C70.2907 100.776 77.6507 102.8 83.784 106.848C89.9173 110.896 94.272 116.355 96.848 123.224V102.064H122.608V204.368C122.608 213.813 120.707 222.277 116.904 229.76C113.224 237.365 107.643 243.315 100.16 247.608C92.8 251.901 83.8453 254.048 73.296 254.048C58.576 254.048 46.6773 250.552 37.6 243.56C28.5227 236.568 23.0027 227.061 21.04 215.04H46.616C48.088 220.192 50.9093 224.179 55.08 227C59.3733 229.944 64.832 231.416 71.456 231.416C79.0613 231.416 85.1947 229.147 89.856 224.608C94.5173 220.192 96.848 213.445 96.848 204.368V182.656C94.272 189.525 89.9173 195.045 83.784 199.216C77.6507 203.264 70.2907 205.288 61.704 205.288C53.1173 205.288 45.3893 203.203 38.52 199.032C31.6507 194.861 26.2533 188.851 22.328 181C18.5253 173.027 16.624 163.704 16.624 153.032C16.624 142.36 18.5253 133.099 22.328 125.248C26.2533 117.275 31.6507 111.203 38.52 107.032C45.3893 102.861 53.1173 100.776 61.704 100.776ZM69.8 123.408C61.704 123.408 55.2027 126.045 50.296 131.32C45.3893 136.595 42.936 143.832 42.936 153.032C42.936 162.232 45.3893 169.469 50.296 174.744C55.2027 179.896 61.704 182.472 69.8 182.472C77.6507 182.472 84.0907 179.835 89.12 174.56C94.272 169.163 96.848 161.987 96.848 153.032C96.848 143.955 94.272 136.779 89.12 131.504C84.0907 126.107 77.6507 123.408 69.8 123.408ZM182.184 100.776C192.12 100.776 201.013 102.861 208.864 107.032C216.837 111.203 223.093 117.275 227.632 125.248C232.17 133.099 234.44 142.36 234.44 153.032C234.44 163.704 232.17 172.965 227.632 180.816C223.093 188.667 216.837 194.739 208.864 199.032C201.013 203.203 192.12 205.288 182.184 205.288C172.248 205.288 163.293 203.203 155.32 199.032C147.469 194.739 141.274 188.667 136.736 180.816C132.197 172.965 129.928 163.704 129.928 153.032C129.928 142.36 132.197 133.099 136.736 125.248C141.274 117.275 147.469 111.203 155.32 107.032C163.293 102.861 172.248 100.776 182.184 100.776ZM182.184 123.224C174.946 123.224 168.813 125.8 163.784 130.952C158.754 135.981 156.24 143.341 156.24 153.032C156.24 162.723 158.754 170.144 163.784 175.296C168.813 180.325 174.946 182.84 182.184 182.84C189.421 182.84 195.554 180.325 200.584 175.296C205.613 170.144 208.128 162.723 208.128 153.032C208.128 143.341 205.613 135.981 200.584 130.952C195.554 125.8 189.421 123.224 182.184 123.224Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_818_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.832 72.808C380.832 68.6373 382.304 65.264 385.248 62.688C388.192 59.9893 392.056 58.64 396.84 58.64C401.624 58.64 405.488 59.9893 408.432 62.688C411.376 65.264 412.848 68.6373 412.848 72.808C412.848 76.856 411.376 80.2293 408.432 82.928C405.488 85.504 401.624 86.792 396.84 86.792C392.056 86.792 388.192 85.504 385.248 82.928C382.304 80.2293 380.832 76.856 380.832 72.808ZM409.72 102.064V204H383.776V102.064H409.72ZM451.774 121.568C455.577 115.067 460.606 109.976 466.862 106.296C473.118 102.493 480.11 100.592 487.838 100.592V128.376H480.294C461.281 128.376 451.774 137.208 451.774 154.872V204H425.83V102.064H451.774V121.568ZM534.765 100.776C543.352 100.776 550.712 102.8 556.845 106.848C562.979 110.896 567.333 116.355 569.909 123.224V102.064H595.669V204H569.909V182.656C567.333 189.525 562.979 195.045 556.845 199.216C550.712 203.264 543.352 205.288 534.765 205.288C526.179 205.288 518.451 203.203 511.581 199.032C504.712 194.861 499.315 188.851 495.389 181C491.587 173.027 489.685 163.704 489.685 153.032C489.685 142.36 491.587 133.099 495.389 125.248C499.315 117.275 504.712 111.203 511.581 107.032C518.451 102.861 526.179 100.776 534.765 100.776ZM542.861 123.408C534.765 123.408 528.264 126.045 523.357 131.32C518.451 136.595 515.997 143.832 515.997 153.032C515.997 162.232 518.451 169.469 523.357 174.744C528.264 179.896 534.765 182.472 542.861 182.472C550.712 182.472 557.152 179.835 562.181 174.56C567.333 169.163 569.909 161.987 569.909 153.032C569.909 143.955 567.333 136.779 562.181 131.504C557.152 126.107 550.712 123.408 542.861 123.408ZM637.765 67.84V204H611.821V67.84H637.765Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_818_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.735 206H324L374 72H349.551L320.507 149.174C317.934 155.956 315.176 164.205 311.868 175.937C308.926 165.122 306.353 157.239 303.412 149.174L274 72H249L299.735 206Z",
    fill: "#A400FE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    filter: "url(#filter2_b_818_165)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.735 215H305L355 81H330.551L301.507 158.174C298.934 164.956 296.176 173.205 292.868 184.937C289.926 174.122 287.353 166.239 284.412 158.174L255 81H230L280.735 215Z",
    fill: "#7ED2F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_818_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.735 215H304L354 81H329.551L300.507 158.174C297.934 164.956 295.176 173.205 291.868 184.937C288.926 174.122 286.353 166.239 283.412 158.174L254 81H229L279.735 215Z",
    fill: "url(#paint0_linear_818_165)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_818_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.624 211H314.912L364.96 76.496H340.488L311.416 153.96C308.84 160.768 306.08 169.048 302.768 180.824C299.824 169.968 297.248 162.056 294.304 153.96L264.864 76.496H239.84L290.624 211Z",
    fill: "#FCFCFC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.415 211L280 215H304L315 211H291.415Z",
    fill: "#7ED2F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240 76.5L229 80.9999L243.5 86L240 76.5Z",
    fill: "#7ED2F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M349 72L340 76.5L364.5 77L373.5 72H349Z",
    fill: "#A400FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_818_165",
    x: 276.832,
    y: -45.3601,
    width: 464.933,
    height: 354.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_818_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_818_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_818_165",
    x: 135,
    y: -42,
    width: 353,
    height: 362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 57
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_818_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_818_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_818_165",
    x: 116,
    y: -33,
    width: 353,
    height: 362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 57
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_818_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_818_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_818_165",
    x: 115,
    y: -33,
    width: 353,
    height: 362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 57
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_818_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_818_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_818_165",
    x: 135.84,
    y: -27.5039,
    width: 333.12,
    height: 342.504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_818_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_818_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_818_165",
    x1: 249.097,
    y1: 144.496,
    x2: 280.913,
    y2: 144.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED2F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoViralWhiteLogo);
export default __webpack_public_path__ + "static/media/goViralWhiteLogo.9437d8750c95e702ce6753b4ce77f572.svg";
export { ForwardRef as ReactComponent };